import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { LetDirective } from '@ngrx/component';
import { ViessmannUIModule } from '../../projects/ui';
import { DemoSettingsRoutingModule } from './demo-settings-routing.module';
import { DemoSettingsComponent } from './demo-settings/demo-settings.component';

@NgModule({
  declarations: [DemoSettingsComponent],
  imports: [
    LetDirective,
    TranslateModule,
    CommonModule,
    ViessmannUIModule,
    DemoSettingsRoutingModule,
  ],
})
export class DemoSettingsModule {}
